<div [ngClass]="theme$ | async">
  <div class="mat-typography mat-app-background">
    <app-nav></app-nav>
    <app-toolbar *ngIf="this.showToolbar" ></app-toolbar>
    <router-outlet></router-outlet>
    <footer></footer>
  </div>
</div>
